
import React from 'react';
import Layout from '@/components/layout/Layout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { TrendingUp, BarChart3, Database, Calendar } from 'lucide-react';
import { PriceDownTable } from '@/components/price-down/PriceDownTable';

const Overview: React.FC = () => {
  return (
    <Layout>
      <div className="container mx-auto p-6">
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-4">
            <TrendingUp className="h-8 w-8 text-green-600" />
            <h1 className="text-3xl font-bold text-gray-900">Price Benchmarking Overview</h1>
          </div>
          <p className="text-gray-600">
            Comprehensive price analysis and market intelligence across all sources
          </p>
        </div>

        <div className="space-y-6">
          {/* Summary Statistics Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <Card>
              <CardHeader className="pb-3">
                <CardTitle className="text-sm font-medium text-gray-600">Total Price Entries</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="flex items-center gap-2">
                  <Database className="h-5 w-5 text-blue-600" />
                  <span className="text-2xl font-bold">--</span>
                </div>
                <p className="text-xs text-gray-500 mt-1">Across all sources</p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader className="pb-3">
                <CardTitle className="text-sm font-medium text-gray-600">Active Products</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="flex items-center gap-2">
                  <BarChart3 className="h-5 w-5 text-green-600" />
                  <span className="text-2xl font-bold">--</span>
                </div>
                <p className="text-xs text-gray-500 mt-1">Being tracked</p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader className="pb-3">
                <CardTitle className="text-sm font-medium text-gray-600">Latest Update</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="flex items-center gap-2">
                  <Calendar className="h-5 w-5 text-orange-600" />
                  <span className="text-2xl font-bold">--</span>
                </div>
                <p className="text-xs text-gray-500 mt-1">Last entry date</p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader className="pb-3">
                <CardTitle className="text-sm font-medium text-gray-600">Data Sources</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="flex items-center gap-2">
                  <TrendingUp className="h-5 w-5 text-purple-600" />
                  <span className="text-2xl font-bold">5</span>
                </div>
                <p className="text-xs text-gray-500 mt-1">Active sources</p>
              </CardContent>
            </Card>
          </div>

          {/* Price Comparison Section */}
          <Card>
            <CardHeader>
              <CardTitle>Price Comparison</CardTitle>
              <CardDescription>Compare prices across different sources</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="flex items-center justify-center h-32 text-gray-500">
                <p>Price comparison table will be implemented in Phase 3</p>
              </div>
            </CardContent>
          </Card>

          {/* Market Trends Section */}
          <Card>
            <CardHeader>
              <CardTitle>Market Trends</CardTitle>
              <CardDescription>Price trends and market analysis</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="flex items-center justify-center h-32 text-gray-500">
                <p>Charts and trend analysis will be implemented in Phase 4</p>
              </div>
            </CardContent>
          </Card>

          {/* ChipChip Price Down Overview */}
          <PriceDownTable />
        </div>
      </div>
    </Layout>
  );
};

export default Overview;
